/* ★ GALERI WORKFLOW — simpanan Firestore (admin) · 26 Okt 2026
 *
 * SATU doc `config/workflow_galeri` = { senarai: [workflow…], dikemaskini }.
 * Kenapa doc config, bukan koleksi baharu: rules `config/{docId}` = baca/tulis admin SEDIA ADA →
 *   tiada perubahan rules, tiada deploy rules. Saiz terkawal: had 100 workflow × ~0.5 KB (jauh bawah 1 MB).
 * ⚠️ Bila page dibuka kepada PELANGGAN: rules `config/workflow_galeri` perlu `allow read: if request.auth != null`
 *   + deploy rules (docs/ai/webapp.md §1 — suis config baharu yang dibaca client), kalau tidak card kosong senyap.
 * Setiap tulisan = transaksi (baca → ubah satu item → tulis) supaya dua tab admin tidak menindih satu sama lain.
 * Semakan nilai: utils/galeriWorkflow.js normalWorkflow (gagal = melontar dengan ayat jelas).
 */
import { doc, onSnapshot, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { normalWorkflow, bacaSenaraiWorkflow, WORKFLOW_MULA, HAD_WF } from '../utils/galeriWorkflow';

const rujukan = () => doc(db, 'config', 'workflow_galeri');

/**
 * Dengar senarai. onData({ ada, senarai, rosak }) — `ada:false` = doc belum pernah dicipta.
 * @returns fungsi berhenti mendengar
 */
export function dengarGaleriWorkflow(onData, onError) {
    return onSnapshot(rujukan(), (snap) => {
        if (!snap.exists()) { onData({ ada: false, senarai: [], rosak: 0 }); return; }
        const { senarai, rosak } = bacaSenaraiWorkflow(snap.data()?.senarai);
        onData({ ada: true, senarai, rosak });
    }, onError);
}

/** Tambah atau kemas kini SATU workflow (ikut id). Melontar bila nilai rosak / had penuh. */
export async function simpanWorkflow(input) {
    const n = normalWorkflow({ ...input, dikemaskini: Date.now() });
    if (!n.ok) throw new Error(n.ralat);
    await runTransaction(db, async (tx) => {
        const snap = await tx.get(rujukan());
        const senarai = snap.exists() && Array.isArray(snap.data()?.senarai) ? [...snap.data().senarai] : [];
        const i = senarai.findIndex((w) => w?.id === n.wf.id);
        if (i < 0 && senarai.length >= HAD_WF.senarai) {
            throw new Error(`Limit reached (${HAD_WF.senarai} workflows). Delete one first.`);
        }
        if (i >= 0) senarai[i] = n.wf; else senarai.push(n.wf);
        tx.set(rujukan(), { senarai, dikemaskini: serverTimestamp() }, { merge: true });
    });
    return n.wf;
}

/** Padam SATU workflow. Melontar bila ia sudah tiada (cth dipadam di tab lain). */
export async function padamWorkflow(id) {
    await runTransaction(db, async (tx) => {
        const snap = await tx.get(rujukan());
        const senarai = snap.exists() && Array.isArray(snap.data()?.senarai) ? snap.data().senarai : [];
        const baki = senarai.filter((w) => w?.id !== id);
        if (baki.length === senarai.length) throw new Error('This workflow no longer exists. The list has been refreshed.');
        tx.set(rujukan(), { senarai: baki, dikemaskini: serverTimestamp() }, { merge: true });
    });
}

/** Muat 13 workflow permulaan — HANYA bila senarai masih kosong (tidak menindih kerja admin). */
export async function muatWorkflowMula() {
    const sah = WORKFLOW_MULA.map((w) => normalWorkflow({ ...w, dikemaskini: Date.now() }));
    const gagal = sah.find((s) => !s.ok);
    if (gagal) throw new Error(`Starter list is invalid: ${gagal.ralat}`);
    await runTransaction(db, async (tx) => {
        const snap = await tx.get(rujukan());
        const sedia = snap.exists() && Array.isArray(snap.data()?.senarai) ? snap.data().senarai : [];
        if (sedia.length > 0) throw new Error('The list already has workflows — starter list not loaded.');
        tx.set(rujukan(), { senarai: sah.map((s) => s.wf), dikemaskini: serverTimestamp() }, { merge: true });
    });
}
